/**
 * @fileoverview Date/Time Input - Enter a date and time
 *
 * @author Chris Williams (cwilliams@yext.com)
 */
goog.module('yext.social.post.DateTimeInput');
goog.module.declareLegacyNamespace();

const string = goog.require('goog.string');
const yext = goog.require('yext');
const localization = goog.require('yext.localization');
const DateInputView = goog.require('yext.ui.DateInputView');

/**
 * @constructor
 * @param {function()} onChange
 */
const DateTimeInput = function(onChange) {
  this.onChange_ = onChange;
};

/**
 * @param {Date} date
 * @return {string}
 */
DateTimeInput.formatTime = function(date) {
  if (!date) {
    return '';
  }
  var hours = date.getHours() > 12 ? date.getHours() - 12 : date.getHours();
  var ampm = date.getHours() >= 12 ? 'PM' : 'AM';
  if (hours === 0) {
    hours = 12;
  }
  var minutes = date.getMinutes() < 10
      ? '0' + date.getMinutes()
      : date.getMinutes();
  return hours + ':' + minutes + ' ' + ampm;
};

/**
 * @param {Date} datetime
 * @return {!jQueryElement}
 */
DateTimeInput.prototype.buildElement = function(datetime) {
  var $timePicker;
  var datePicker = new DateInputView().init();

  var handleChange = function() {
    var date = datePicker.getDate();
    var time = $timePicker.timepicker('getTime');
    if (!date || !time) {
      this.onChange_(undefined);
      return;
    }
    var newDate = new Date(date.getFullYear(),
      date.getMonth(),
      date.getDate(),
      time.getHours(),
      time.getMinutes(),
      time.getSeconds());
    this.onChange_(newDate);
  }.bind(this);

  if (datetime) {
    datePicker.set(datetime);
  }
  datePicker.onChange(handleChange);

  $timePicker =
    $('<input>',
      {
        'timepicker': {},
        'width': 80,
        'type': 'text',
        'val': DateTimeInput.formatTime(datetime),
        'on': {'changeTime': handleChange},
        'inputchange': handleChange,
      });

  var $datePicker = $('<span>');
  datePicker.mount($datePicker);

  return $('<div>',
    {
      'class': 'date-time-input',
      'append': [
        $datePicker,
        $('<span>',
          {
            'class': 'date-time-at',
            // TRANSLATORS: For a time. E.g. Wed, Nov 8 at 1:00 PM
            'text': yext.msg('at'),
          }),
        $timePicker,
      ],
    });
};

exports = DateTimeInput;
